import React from "react";
import { Step, StepLabel, Stepper } from "@material-ui/core";

const StepperList = ({ activeStep, steps, skipped }) => {
    const isStepSkipped = (step) => skipped.has(step);

    return (
        <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                if (isStepSkipped(index)) {
                    stepProps.completed = false;
                }

                return (
                    <Step
                        key={label}
                        {...stepProps}
                    >
                        <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                );
            })}
        </Stepper>
    );
};

export default StepperList;
